import { useEffect, useState } from 'react';

export function BackToTopFab() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', handler, { passive: true });
    return () => window.removeEventListener('scroll', handler);
  }, []);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <md-fab
      id="backToTop"
      size="small"
      aria-label="Back to top"
      className={`back-to-top ${visible ? 'visible' : ''}`}
      onClick={scrollToTop}
    >
      <md-icon slot="icon">arrow_upward</md-icon>
    </md-fab>
  );
}
